import { render, staticRenderFns } from "./PSurvey.vue?vue&type=template&id=818eaba4&"
import script from "./PSurvey.vue?vue&type=script&lang=ts&"
export * from "./PSurvey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports